import type { FormAdditionalSettingsFormType, PromoCodeSettingsFormType } from './sp-form-additional-settings.type';

import { FormControl, FormGroup } from '@angular/forms';

export const formAdditionalSettingsForm = (
    isEnabledCaptcha: boolean = false,
    captchaLimit: number = null
): FormGroup<FormAdditionalSettingsFormType> =>
    new FormGroup<FormAdditionalSettingsFormType>({
        actionAfterConfirmType: new FormControl(null),
        subscriptionMessage: new FormControl(null),
        openLink: new FormControl(null),
        updateExistingContact: new FormControl(null),
        isEnabledCaptcha: new FormControl(isEnabledCaptcha),
        captchaLimit: new FormControl(captchaLimit),
        promoCodeSettings: new FormGroup<PromoCodeSettingsFormType>({
            isEnabled: new FormControl(null),
            label: new FormControl(null),
            placeholder: new FormControl(null),
            selectedPromoCode: new FormControl(null),
        }),
        isEnableCorporateEmail: new FormControl(null),
    });
